import React, { useMemo } from "react";
import Tooltip from "antd/lib/tooltip";
import { kFormatter } from "../../../redux/constants";
import { useSelector } from "react-redux";
import fx from "../../../assets/WidgetMaker/FX.svg";
import InfoIcon from "../../../assets/Info_Icon.svg";
import InfoIconYellow from "../../../assets/Info_Icon_Yellow.svg";
import CustomFooterContent from "./CustomFooterContent";

const CustomCardFooter = ({
  el,
  data,
  custom_card_settings,
  PdfDownloadStatus,
  PptGeneratingStatus,
  isPreviewState,
  widget_id,
  isHideGlobal,
  deepDive,
  setAutoPlay,
  BrandPosts,
  postDetail,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  // console.log(
  //   "CustomCardFooter el ==>",
  //   el,
  //   "settings ==>",
  //   custom_card_settings
  // );
  const custom_card_settings_list = useMemo(
    () =>
      custom_card_settings?.card_footer_3?.map((d) =>
        d?.attribute?.toLowerCase()
      ),
    [custom_card_settings]
  );
  return (
    <>
      <div>
        {custom_card_settings?.card_footer_1?.length ? "Footer 1" : ""}

        {custom_card_settings?.card_footer_2?.length ? (
          <>
            <CustomFooterContent
              data={data}
              isPreviewState={isPreviewState}
              PdfDownloadStatus={PdfDownloadStatus}
              PptGeneratingStatus={PptGeneratingStatus}
              el={el}
              footerMetaData={custom_card_settings?.card_footer_2}
              isHideGlobal={isHideGlobal}
              deepDive={deepDive}
              setAutoPlay={setAutoPlay}
              postDetail={postDetail}
            />
          </>
        ) : (
          ""
        )}

        {!BrandPosts && custom_card_settings?.card_footer_3?.length ? (
          <>
            {el?.PlatformID === 7 || el?.PlatformID === 30 ? (
              ""
            ) : (
              <div className="card-footer text-center bg__white text_regular d-flex align-items-top pt-2 pb-2 pl-15 pr-15 border-top border-color">
                {custom_card_settings_list?.includes("engagement") ? (
                  <div
                    className="mr-15 brandPosts__footerWrap"
                    style={{ width: "25%", flexGrow: "1" }}
                  >
                    <div className="text_regular text-grayLight white-space-nowrap">
                      Engagement
                      {authParams?.screen_id === "000-000-556" &&
                        widget_id === "000-100-965" && (
                          <>
                            <span>:</span>
                          </>
                        )}
                    </div>
                    <div
                      className={`${
                        PdfDownloadStatus ? "" : "font-size18"
                      } text_heading-Rubik line-height-normal`}
                    >
                      {PdfDownloadStatus ? (
                        <>
                          <div>
                            {kFormatter(el?.Engagement)}{" "}
                            {el?.PlatformID === 3 && el?.isPromoted === 5 ? (
                              <Tooltip
                                title={
                                  "This Post Has No AD ID, So Engagement Only Includes Basic Stats Like Likes And Comments."
                                }
                              >
                                <img
                                  src={InfoIconYellow}
                                  style={{ maxWidth: "1.5rem" }}
                                  className="mr-1 cursor-pointer"
                                  alt="info"
                                />
                              </Tooltip>
                            ) : el?.engagement_fx ? (
                              <Tooltip title={el?.Engagement_text}>
                                <img
                                  src={fx}
                                  style={{ maxWidth: "1.5rem" }}
                                  className="mr-1 cursor-pointer"
                                  alt="fx"
                                />
                              </Tooltip>
                            ) : (
                              ""
                            )}{" "}
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className={
                              authParams?.screen_id === "000-000-556"
                                ? "counts-yellow"
                                : "counts"
                            }
                          >
                            <Tooltip title={el?.Engagement?.toLocaleString()}>
                              {kFormatter(el?.Engagement)}{" "}
                            </Tooltip>
                          </div>
                          {el?.PlatformID === 3 && el?.isPromoted === 5 ? (
                            <Tooltip
                              title={
                                "This Post Has No AD ID, So Engagement Only Includes Basic Stats Like Likes And Comments."
                              }
                            >
                              <img
                                src={InfoIconYellow}
                                style={{ maxWidth: "1.5rem" }}
                                className="mr-1 cursor-pointer"
                                alt="info"
                              />
                            </Tooltip>
                          ) : el?.engagement_fx ? (
                            <Tooltip title={el?.Engagement_text}>
                              <img
                                src={fx}
                                style={{ maxWidth: "1.5rem" }}
                                className="mr-1 cursor-pointer"
                                alt="fx"
                              />
                            </Tooltip>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </div>
                    {/* <Progress
                    percent={el?.Engagement}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                  /> */}
                  </div>
                ) : (
                  ""
                )}
                {custom_card_settings_list?.includes("engagement_rate") ? (
                  <div
                    className="mr-15 brandPosts__footerWrap"
                    style={{ width: "25%", flexGrow: "1" }}
                  >
                    <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                      <Tooltip title="Engagement Rate">
                        <div className="white-space-nowrap">
                          Eng. Rate
                          {authParams?.screen_id === "000-000-556" &&
                            widget_id === "000-100-965" && (
                              <>
                                <span>:</span>
                              </>
                            )}
                        </div>
                      </Tooltip>
                    </div>
                    <div
                      className={`${
                        PdfDownloadStatus ? "" : "font-size18"
                      } text_heading-Rubik line-height-normal`}
                    >
                      {PdfDownloadStatus ? (
                        <>
                          <div>
                            {kFormatter(el?.Engagement_rate)}{" "}
                            {el?.Engagement_rate_fx ? (
                              <Tooltip title={el?.Engagement_rate_text}>
                                <img
                                  src={fx}
                                  style={{ maxWidth: "1.5rem" }}
                                  className="mr-1 cursor-pointer"
                                  alt="fx"
                                />
                              </Tooltip>
                            ) : (
                              ""
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="counts">
                            <Tooltip
                              title={el?.Engagement_rate?.toLocaleString()}
                            >
                              {kFormatter(el?.Engagement_rate)}
                            </Tooltip>
                          </div>
                          {el?.Engagement_rate_fx ? (
                            <Tooltip title={el?.Engagement_rate_text}>
                              <img
                                src={fx}
                                style={{ maxWidth: "1.5rem" }}
                                className="mr-1 cursor-pointer"
                                alt="fx"
                              />
                            </Tooltip>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </div>
                    {/* <Progress
                    percent={el?.Engagement}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                  /> */}
                  </div>
                ) : (
                  ""
                )}
                {custom_card_settings_list?.includes("reach") ? (
                  <div
                    className="mr-15 brandPosts__footerWrap"
                    style={{ width: "25%", flexGrow: "1" }}
                  >
                    <div
                      className={`text_regular text-grayLight d-inline-flex align-items-center ${
                        el?.reach_fx ? "cursor-pointer" : ""
                      }`}
                    >
                      {el?.reach_fx ? (
                        <Tooltip title="Estimated Reach">
                          <div className="white-space-nowrap">
                            Est. Reach
                            {authParams?.screen_id === "000-000-556" &&
                              widget_id === "000-100-965" && (
                                <>
                                  <span>:</span>
                                </>
                              )}
                          </div>
                        </Tooltip>
                      ) : (
                        <div className="white-space-nowrap">
                          Reach
                          {authParams?.screen_id === "000-000-556" &&
                            widget_id === "000-100-965" && (
                              <>
                                <span>:</span>
                              </>
                            )}
                        </div>
                      )}
                      {el?.reach_i && (
                        <Tooltip title="It looks like this video post has been watched by the same viewers multiple times.">
                          <img src={InfoIcon} alt="InfoIcon" className="ml-1" />
                        </Tooltip>
                      )}
                    </div>
                    <div
                      className={`${
                        PdfDownloadStatus ? "" : "font-size18"
                      } text_heading-Rubik line-height-normal`}
                    >
                      {PdfDownloadStatus ? (
                        <>
                          <div>
                            {kFormatter(el?.Reach)}{" "}
                            {el?.reach_fx && (
                              <Tooltip title={el?.Reach_text}>
                                <img
                                  src={fx}
                                  style={{ maxWidth: "1.5rem" }}
                                  className="mr-1 cursor-pointer"
                                  alt="fx"
                                />
                              </Tooltip>
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className={
                              authParams?.screen_id === "000-000-556"
                                ? "counts-yellow"
                                : "counts"
                            }
                          >
                            {" "}
                            <Tooltip title={el?.Reach?.toLocaleString()}>
                              {kFormatter(el?.Reach)}
                            </Tooltip>
                          </div>
                          {el?.reach_fx && (
                            <Tooltip title={el?.Reach_text}>
                              <img
                                src={fx}
                                style={{ maxWidth: "1.5rem" }}
                                className="mr-1 cursor-pointer"
                                alt="fx"
                              />
                            </Tooltip>
                          )}
                        </>
                      )}
                    </div>
                    {/* <Progress
                    percent={el?.Reach}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                  /> */}
                  </div>
                ) : (
                  ""
                )}
                {custom_card_settings_list?.includes("impression") ? (
                  <div
                    className="brandPosts__footerWrap"
                    style={{ width: "25%", flexGrow: "1" }}
                  >
                    {el?.impression_fx ? (
                      <Tooltip title="Estimated Impression">
                        <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                          {" "}
                          {PdfDownloadStatus ? "Est. Impr." : "Est. Impression"}
                        </div>
                      </Tooltip>
                    ) : (
                      <div className="text_regular text-grayLight white-space-nowrap">
                        Impression
                        {authParams?.screen_id === "000-000-556" &&
                          widget_id === "000-100-965" && (
                            <>
                              <span>:</span>
                            </>
                          )}
                      </div>
                    )}
                    <div
                      className={`${
                        PdfDownloadStatus ? "" : "font-size18"
                      } text_heading-Rubik line-height-normal`}
                    >
                      {PdfDownloadStatus ? (
                        <>
                          <div>
                            {kFormatter(el?.Impression, false, true)}
                            {el?.impression_fx && (
                              <Tooltip title={el?.Impression_text}>
                                <img
                                  src={fx}
                                  style={{ maxWidth: "1.5rem" }}
                                  className="mr-1 cursor-pointer"
                                  alt="fx"
                                />
                              </Tooltip>
                            )}
                          </div>
                        </>
                      ) : (
                        <>
                          <div
                            className={
                              authParams?.screen_id === "000-000-556"
                                ? "counts-yellow"
                                : "counts"
                            }
                          >
                            <Tooltip title={el?.Impression?.toLocaleString()}>
                              {kFormatter(el?.Impression, false, true)}
                            </Tooltip>
                          </div>
                          {el?.impression_fx && (
                            <Tooltip title={el?.Impression_text}>
                              <img
                                src={fx}
                                style={{ maxWidth: "1.5rem" }}
                                className="mr-1 cursor-pointer"
                                alt="fx"
                              />
                            </Tooltip>
                          )}
                        </>
                      )}
                    </div>
                    {/* <Progress
                    percent={el?.Impression}
                    showInfo={false}
                    trailColor={"#c0c2c5"}
                  /> */}
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default CustomCardFooter;
